import { useEffect } from "react";

export function useKeyboardNavigation() {
  useEffect(() => {
    return () => undefined;
  }, []);
}
